import React, { useEffect, useRef, useState } from 'react';
import { MdCancel } from "react-icons/md";
//helpers
import TableContainer from '../../../helpers/TableContainer';
//css
import './RequestResponseModal.css';

export default function RequestResponseModal(
    {
        request,
        response,
        requestMetadata,
        responseMetadata,
        closeModal
    }
) {
    const requestRef = useRef(null);
    const responseRef = useRef(null);
    const [requestTableWidth, setRequestTableWidth] = useState("auto");
    const [responseTableWidth, setResponseTableWidth] = useState("auto");

    useEffect(() => {
        if (requestRef.current) {
            const computeWidth = window.getComputedStyle(requestRef.current).width;
            setRequestTableWidth(computeWidth);
        }
        if (responseRef.current) {
            const computeWidth = window.getComputedStyle(responseRef.current).width;
            setResponseTableWidth(computeWidth);
        }
    }, [])

    const keysListToRemove = ['_class', 'stage', 'metadata'];
    const removekeys = (obj, keysToRemove) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
        )
    }
    request = removekeys(request, keysListToRemove);
    response = removekeys(response, keysListToRemove);

    return (
        <div className='request-response-data' id='request-response-data'>
            <span className='cancel-icon' onClick={closeModal}>
                <MdCancel color="#07598D" size="20px" />
            </span>
            <div className='request-response-content'>
                <div className='request-content'>
                    <TableContainer title="Request" content={request} tableRef={requestRef} />
                    {requestMetadata && <TableContainer title="Request Metadata" content={requestMetadata} width={requestTableWidth} />}
                </div>
                <div className='response-content'>
                    <TableContainer title="Response" content={response} tableRef={responseRef} />
                    {responseMetadata && <TableContainer title="Response Metadata" content={responseMetadata} width={responseTableWidth} />}
                </div>
            </div>
        </div>
    );
}
